import LayoutLeftIcon from "@redotech/redo-icons/layout-left.svg";
import LayoutRightIcon from "@redotech/redo-icons/layout-right.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Separator } from "@redotech/redo-web/components/ui/separator";
import { Flex } from "@redotech/redo-web/flex";
import ChevronLeftIcon from "@redotech/redo-web/icon-old/chevron-left.svg";
import { Text } from "@redotech/redo-web/text";
import { getDateTimeString } from "@redotech/util/date-format";
import { memo, type ReactNode } from "react";

export interface ConversationHeaderProps {
  actionToolbar?: ReactNode;
  customerName: string;
  latestMessageTime: Date | null;
  leftPanelOpen?: boolean;
  onBack: () => void;
  onToggleLeftPanel?: () => void;
  onToggleRightPanel?: () => void;
  rightPanelOpen?: boolean;
}

export const ConversationHeader = memo(function ConversationHeader({
  actionToolbar,
  customerName,
  latestMessageTime,
  leftPanelOpen,
  onBack,
  onToggleLeftPanel,
  onToggleRightPanel,
  rightPanelOpen,
}: ConversationHeaderProps) {
  return (
    <Flex
      align="center"
      bgColor="primary"
      borderBottomWidth="1px"
      borderColor="primary"
      borderStyle="solid"
      gap="md"
      justify="space-between"
      pb="md"
      pl="xl"
      pr="xl"
      pt="md"
      shrink={0}
    >
      <Flex align="center" gap="md">
        {onToggleLeftPanel && (
          <RedoButton
            hierarchy={leftPanelOpen ? "primary" : "secondary"}
            IconLeading={LayoutLeftIcon}
            onClick={onToggleLeftPanel}
            size="sm"
          />
        )}
        <RedoButton
          hierarchy="secondary"
          IconLeading={ChevronLeftIcon}
          onClick={onBack}
          size="sm"
        />
        <Text fontSize="md" fontWeight="semibold" textColor="primary">
          {customerName}
        </Text>
        {latestMessageTime && (
          <>
            <Separator className="h-5" orientation="vertical" />
            <Text fontSize="md" textColor="tertiary">
              {getDateTimeString(latestMessageTime)}
            </Text>
          </>
        )}
      </Flex>
      <Flex align="center" gap="sm">
        {actionToolbar}
        {onToggleRightPanel && (
          <RedoButton
            hierarchy={rightPanelOpen ? "primary" : "secondary"}
            IconLeading={LayoutRightIcon}
            onClick={onToggleRightPanel}
            size="sm"
          />
        )}
      </Flex>
    </Flex>
  );
});
